import BaseModel from './base'
import ContactService from '../../services/ContactServices'
import LocationService from '../../services/LocationServices'
import {TaskSearchPayload} from "../../pmd/pages/tasks/types";
import TaskService from "../../services/TaskService";

export interface ITask {
  title: string
  body: string
  dueDate: string
  status?: string
  assignedTo: string
  completed?: boolean
  contactId: string
  id?:string
  businessId?:string
}

export default class Task extends BaseModel {
  static requestBodyWhiteList = [
    'title',
    'body',
    'dueDate',
    'completed',
    'assignedTo',
    'recurringTaskId'
  ]

  isAgencyTask = false
  // Methods
  constructor(data: ITask, isAgencyTask = false) {
    super(Task.requestBodyWhiteList, data)
    this.isAgencyTask = isAgencyTask
  }



  async save(): Promise<{ [key: string]: any }> {
    return new Promise(async (resolve, reject) => {
      try {
        let response: { [key: string]: any }

        if (this.newRecord) {
          const selectedData = {...(Task.requestBodyWhiteList.length === 0
            ? this.data
            : Task.requestBodyWhiteList.reduce((acc, cv) => {
                acc[cv] = this.data[cv]
                return acc
              }, {})),...this.isAgencyTask?{isAgencyTask:true}:{}}

          if(this.contactId){

            response = await ContactService.Tasks.create(
              this.contactId,
              selectedData
            )
          }else{
            response = await LocationService.Tasks.accountTaskCreate(
              this.accountId || this.locationId,
              selectedData

            )
          }
          if (response.task) {
            this.data.id = response.task.id
            this.newRecord = false
          }
        } else if(this.accountId || this.locationId) {
          response = await LocationService.Tasks.accountTaskUpdate(
            this.accountId || this.locationId,
            this.id,
            this.updatedData
          )
        }
        resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  }

  async delete(locationId: string,TaskId:string, contactId:string): Promise<{ [key: string]: any }> {
    return new Promise(async (resolve, reject) => {
      try {
        let response: { [key: string]: any }
        if(contactId){
          response = await ContactService.Tasks.delete(contactId, TaskId)
        }else{
           response = await LocationService.Tasks.delete(locationId, TaskId)
        }
        resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  }

  static async list(queryData:{ [key: string]: any }): Promise<Task[]> {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await LocationService.Tasks.list(queryData)
        resolve(response.tasks.map(n => new Task(n)))
      } catch (error) {
        reject(error)
      }
    })
  }

  static async search(queryData: TaskSearchPayload): Promise<Task[]> {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await TaskService.search(queryData)
        const tasks = response?.data?.tasks
        resolve(tasks.map(n => new Task({...n, id: n._id})))
      } catch (error) {
        reject(error)
      }
    })
  }

  static async read(locationId: string, taskId: string): Promise<Task> {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await LocationService.Tasks.read(locationId, taskId)
        resolve(new Task(response.task))
      } catch (error) {
        reject(error)
      }
    })
  }


  // Getters and Setters
  get title(): string {
    return this.data.title
  }

  set title(value: string) {
    this.data.title = value
    this.updatedData.title = value
  }

  get dueDate(): Date {
    return this.data.dueDate
  }

  set dueDate(value: Date) {
    this.data.dueDate = value
    this.updatedData.dueDate = value
  }

  get status(): string {
    return this.data.status
  }

  set status(value: string) {
    this.data.status = value
    this.updatedData.status = value
  }

  get assignedTo(): string {
    return this.data.assignedTo
  }

  set assignedTo(value: string) {
    this.data.assignedTo = value
    this.updatedData.assignedTo = value
  }

  get body(): string {
    return this.data.body
  }

  set body(value: string) {
    this.data.body = value
    this.updatedData.body = value
  }

  get completed(): boolean {
    return this.data.completed
  }

  set completed(value: boolean) {
    this.data.completed = value
    this.updatedData.completed = value
  }

  get contactId(): string {
    return this.data.contactId
  }

  set contactId(value: string) {
    this.data.contactId = value
    this.updatedData.contactId = value
  }

  get locationId(): string {
    return this.data.locationId
  }

  set locationId(value: string) {
    this.data.locationId = value
    this.updatedData.locationId = value
  }

  get accountId(): string {
    return this.data.accountId
  }

  set accountId(value: string) {
    this.data.accountId = value
    this.updatedData.accountId = value
  }

  get businessId(){
    return this.data.business_id
  }

  set businessId(value: string){
    this.data.business_id = value
  }

  get recurringTaskId(){
    return this.data.recurringTaskId
  }

  set recurringTaskId(value: string){
    this.data.recurringTaskId = value
    this.updatedData.recurringTaskId = value
  }

}
